import axios from "axios";
import { liveURL } from "../constants/Consts";

const MAIN_URL = `${liveURL}/v1/adminPortal`;

const CREATE_USER = `${MAIN_URL}/createUser`;
const GET_USER = `${MAIN_URL}/getAllUsers`;
const DELETE_USER = `${MAIN_URL}/deleteUser`;
const GET_USER_BY_ID = `${MAIN_URL}/getUserById`;
const UPDATE_USER = `${MAIN_URL}/updateUser`;

// Create a new user
export async function createUser(token, data) {
    try {
      const response = await axios.post(CREATE_USER, data, {
        headers: {
          token: token,
        },
      });
      return response.data;
    } catch (error) {
      console.log("Error creating User:", error);
      return { Result: false, Msg: "Error creating User" };
    }
}

// Get all users
export async function getUsers(token) {
  try {
    const response = await axios.get(GET_USER, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error fetching users:", error);
    return { Result: false, Msg: "Error fetching users" };
  }
}

// Get user by ID
export async function getUserById(token, id) {
  try {
    const response = await axios.get(`${GET_USER_BY_ID}/${id}`, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error fetching user:", error);
    return { Result: false, Msg: "Error fetching user" };
  }
}

// Delete a user
export async function deleteUser(token, id) {
  try {
    const response = await axios.delete(`${DELETE_USER}/${id}`, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error deleting user:", error);
    return { Result: false, Msg: "Error deleting user" };
  }
}

// Update a user
export async function updateUser(token, id, data) {
  try {
    const response = await axios.put(`${UPDATE_USER}/${id}`, data, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error updating user:", error);
    return { Result: false, Msg: "Error updating user" };
  }
}